import React from 'react';



import { About } from "../Biografie/About";

import { Kontakt } from "../Kontakt/Kontakt";
import { Termine } from "../Termine/Termine";
import { Impressum } from "../Impressum/Impressum";
import { useState, useRef } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Newletter } from '../Newsletter';
import instagram from '../../assets/socialmedia/instagram.png';



export const Main = (props) => {
	const isMobile = props.width < 800;
	const [tab, setTab] = useState(0);

	const contentRef = useRef(null);
	const tabsRef = useRef(null); // NEU: Referenz auf die Navbar



	const handleChange = (event, newValue) => {
		if (newValue === 5) {
			window.open('https://drive.google.com/drive/u/1/folders/11V__e8ASwZttEmEPUIAbfB3vwQXfAMT3', '_blank'); // open in new window
			return; // stop updating the tab state
		}

		setTab(newValue);


		// wait for content to render
		setTimeout(() => {
			if (contentRef.current) {
				// Nur auf Desktop hat die Navbar position: sticky
				const navHeight = !isMobile && tabsRef.current
					? tabsRef.current.offsetHeight
					: 0;

				const targetY =
					contentRef.current.getBoundingClientRect().top +
					window.scrollY -
					navHeight;

				window.scrollTo({
					top: targetY,
					behavior: 'smooth',
				});
			}
		}, 0);
	};

	return (
		<div>

			<Box

				className={isMobile ? 'tabs-mobile' : 'tabs-desktop'}
			>
				<div
					ref={tabsRef} // NEU

					className={`tabs-container ${isMobile ? '' : 'tabs-sticky'}`}

				>


					<Tabs
						value={tab}
						onChange={handleChange}
						orientation={isMobile ? 'vertical' : 'horizontal'}
						variant={isMobile ? 'standard' : 'scrollable'}
						sx={{
							width: '100%',
							borderColor: 'divider',
							backgroundColor: 'var(--background)',
							'& .MuiTab-root': {
								fontFamily: "'Inter', sans-serif",
								fontWeight: 500,
								fontSize: '0.85rem',
								letterSpacing: '0.04em',
								color: 'var(--tab-default)',
								'&.Mui-selected': {
									color: 'var(--tab-selected)',
									fontWeight: 600,
								},
							},
						}}
						slotProps={{
							indicator: {
								sx: {
									backgroundColor: 'var(--tab-indicator)',
								},
							},
						}}
					>
						<Tab label="Über mich" />
						<Tab label="Termine" />
						<Tab label="Newsletter" />
						<Tab label="Kontakt" />
						<Tab
							label={
								<img
									src={instagram}
									alt="Instagram"
									className="instagram-icon"
								/>
							}
							onClick={() => window.open('https://www.instagram.com/sophia.kundalini.yoga', '_blank')}
						/>
					</Tabs>


				</div>

				<Box sx={{ p: 3 }} ref={contentRef}>
					{tab === 0 && <About />}
					{tab === 1 && <Termine />}
					{tab === 2 && <Newletter />}
					{tab === 3 && <Kontakt />}
				</Box>
			</Box>

			<Impressum />
		</div>
	);
}

